import { post } from "./base";

export const CompareService = {
  getStateCities: ({ state, runId, query, flagQuery }) => {
    return post("/compare-cities", {
      state,
      run_id: runId,
      query,
      flag_query: flagQuery,
    });
  },
  getCityAtGlance: (payload) => {
    return post("/city-at-glance", payload);
  },
  getCompareCities: (payload) => {
    return post("/city-select/compare", payload);
  },
};
